<template>
  <div>
    <b-modal
      ref="apply-voucher-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="xl"
    >
      <v-form ref="form">
        <b-row class="mb-4">
          <b-col md="4">
            <b-input
              size="sm"
              placeholder="Tìm kiếm"
              v-model="searchText"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col md="1">
            <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <b-table :items="listItem" :fields="fields" bordered hover show-empty>
          <template #empty="scope">
            <h5 class="text-center">Không có voucher nào được gợi ý</h5>
          </template>
          <template v-slot:cell(voucherValue)="row">
            <div v-if="row.item.applyTarget === 'EMPLOYEE_COMMISSION'">
              <small class="d-block text-muted">
                Trừ hoa hồng NV
                <span v-if="row.item.commissionPayer">
                  ({{ commissionPayerLabel(row.item.commissionPayer) }})
                </span>
              </small>
              <b-form-select
                size="sm"
                v-model="row.item.chosenAmount"
                :options="buildAmountOptions(row.item.allowedAmounts)"
                value-field="value"
                text-field="text"
                style="margin-top: 4px; max-width: 180px"
              />
            </div>
            <div v-else-if="row.item.type === DISCOUNT_AMOUNT_TYPE.PERCENT">
              {{ DISCOUNT_AMOUNT_TYPE_NAME[row.item.type] }}
              <span v-text="'Tối đa: '" class="font-weight-bold" />
              <span
                v-text="convertPrice(row.item.maxValue)"
                class="text-warning"
              />
              <div>
                <i class="fa-solid fa-circle-arrow-right"></i>
                {{ convertPrice(row.item.voucherValue) }}
              </div>
            </div>
            <div v-else>
              {{ convertPrice(row.item.voucherValue) }}
            </div>
            <!-- <div class="d-flex justify-content-end">
              <VoucherCumulativeValue
                v-if="row.item.cumluativeValues.length"
                :cumluativeValues="row.item.cumluativeValues"
              />
            </div> -->
          </template>
          <template v-slot:cell(apply)="row">
            <div
              class="text-center btn"
              :class="{ disabled: !isAppliable(row.item) }"
              @click="isAppliable(row.item) && applyVoucherItem(row.item)"
              :title="
                !isAppliable(row.item) ? 'Hãy chọn mức commission' : 'Áp dụng'
              "
            >
              <i
                class="fa fa-arrow-circle-down"
                :class="isAppliable(row.item) ? 'text-success' : 'text-muted'"
                v-b-tooltip.hover
              ></i>
            </div>
          </template>
        </b-table>
        <b-button
          style="font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal"
        >
          Hủy
        </b-button>
      </v-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { convertPrice } from '@/utils/common';
import { cloneDeep } from 'lodash';
import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name';
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
// import VoucherCumulativeValue from '@/view/components/voucher/VoucherCumulativeValue.vue';

export default {
  props: {
    billItemId: { type: [String, Number], default: '' },
    productName: { type: String, default: '' },
    storeId: { type: [String, Number], default: null },
    productId: { type: [String, Number], default: null },
    productAmount: { type: [String, Number], default: 0 },
    customerId: { type: [String, Number], default: null },
    customerType: { type: String, default: 'CUSTOMER' },
    contractId: { type: [String, Number], default: null },
    appliedVoucherIds: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    // VoucherCumulativeValue,
  },
  data() {
    return {
      modalTitle: '',
      searchText: '',
      listItem: [],
      listItemDraff: [],
      fields: [
        {
          key: 'voucherCode',
          label: 'Mã voucher',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'voucherName',
          label: 'Tên chương trình',
          thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
        },
        {
          key: 'voucherValue',
          label: 'Giá trị',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          formatter: (value) => {
            return convertPrice(value);
          },
          tdClass: 'text-right',
        },
        {
          key: 'usable',
          label: 'Lượt còn lại',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          formatter: (value) => {
            return convertPrice(value);
          },
          tdClass: 'text-right',
        },
        {
          key: 'apply',
          label: 'Áp dụng',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '10%',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
      ],
      DISCOUNT_AMOUNT_TYPE_NAME,
      DISCOUNT_AMOUNT_TYPE,
      COMMISSION_PAYER_LABELS: {
        SALE: 'NV bán hàng',
        SHIPPER: 'NV giao hàng',
        TECHNICAL: 'Trưởng nhóm BH',
        CASHIER: 'Sale admin',
        MANAGER: 'Giám đốc showroom',
        ASSISTANT: 'NV kỹ thuật',
      },
    };
  },
  methods: {
    convertPrice,
    async fetchVoucherUsable() {
      const params = {
        productId: this.productId,
        productAmount: this.productAmount,
        storeId: this.storeId,
        customerId: this.customerId,
        customerType: this.customerType,
        contractId: this.contractId,
        // BE dùng để compound discount cho voucher CUSTOMER_SPECIAL
        // (tính % trên giá còn lại sau khi trừ BASE_DISCOUNT + ADDITIONAL_PROMO).
        // Axios sẽ serialize array thành `?appliedVoucherIds=1&appliedVoucherIds=2`.
        appliedVoucherIds: Array.isArray(this.appliedVoucherIds)
          ? this.appliedVoucherIds
          : [],
      };
      ApiService.query('vouchers/usable', { params }).then(({ data }) => {
        const listData = data.data;
        this.listItem = listData.map((element) => {
          return {
            ...element,
            checked: false,
            chosenAmount: null,
          };
        });
        this.listItemDraff = cloneDeep(this.listItem);
      });
    },
    showModal: async function () {
      this.searchText = '';
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Áp dụng voucher cho sản phẩm: <a class='text-primary'>#${this.productName}</a></span>
              </div>`;
      if (this.billItemId) {
        await this.fetchVoucherUsable();
        this.$refs['apply-voucher-modal'].show();
      }
    },
    hideModal: function () {
      this.$refs['apply-voucher-modal'].hide();
    },
    onFilter() {
      const textSearch = this.searchText ? this.searchText.trim() : '';
      this.listItem = this.listItemDraff
        .filter((item) => {
          return (
            item.voucherCode.toLowerCase().indexOf(textSearch.toLowerCase()) >
            -1
          );
        })
        .slice(0, 10);
    },
    commissionPayerLabel(role) {
      return this.COMMISSION_PAYER_LABELS[role] || role;
    },
    buildAmountOptions(amounts) {
      if (!Array.isArray(amounts)) return [];
      return [
        { value: null, text: '-- Chọn mức --' },
        ...amounts.map((a) => ({
          value: a,
          text: Number(a).toLocaleString('vi-VN') + ' đ',
        })),
      ];
    },
    isAppliable(item) {
      if (item.applyTarget === 'EMPLOYEE_COMMISSION') {
        return !!item.chosenAmount;
      }
      return true;
    },
    applyVoucherItem(voucherItem) {
      const isCommission = voucherItem.applyTarget === 'EMPLOYEE_COMMISSION';
      const voucherValue = isCommission
        ? Number(voucherItem.chosenAmount || 0)
        : voucherItem.voucherValue;
      const response = {
        voucherId: voucherItem.voucherId,
        voucherDetailId: voucherItem.voucherDetailId,
        billItemId: this.billItemId,
        voucherCode: voucherItem.voucherCode,
        voucherValue,
        applyTarget: voucherItem.applyTarget,
        commissionPayer: voucherItem.commissionPayer || null,
        chosenAmount: isCommission
          ? Number(voucherItem.chosenAmount || 0)
          : null,
        // cumluativeValues: voucherItem.cumluativeValues,
      };
      this.$emit('applyVoucherItem', response);
      this.hideModal();
    },
  },
};
</script>
